import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import Select from 'react-select';

import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';
import { Progress } from 'reactstrap';
import moment from 'moment';

import * as actions from '../../actions/cliente';

import IconSave from 'react-icons/lib/md/save';


import {api, request, API_URL} from '../../actions/_request';



class KardexProveedor extends React.Component{
  constructor(props) {

        super(props);

        this.state = {
          indice:0,
          progreso:0, 

        };
        
         this.timer = this.timer.bind(this);
    }
    componentDidMount() {

   var intervalId = setInterval(this.timer, 1000);
   let data= this.props.lista;
   // store intervalId in the state so it can be accessed later:
   this.setState({intervalId: intervalId });
}

componentWillUnmount() {
   // use intervalId from the state to clear the interval
   clearInterval(this.state.intervalId);
}

async timer() {
   // setState method is used to update the state
   let self = this;
   
   let {indice,recalcular,progreso} = this.props.cliente;
   if(recalcular==true){
        let data= this.props.lista;
        let max =data.length;
        if(indice<max){  
        console.log('Cliente----->',data[indice]);
        

                  let res = await api().get(`recalcular_saldo_cliente/${data[indice].value}`);
                  
                 indice++;
                 progreso=parseFloat((indice*100)/max).toFixed(2);
                 self.props.progreso({indice:indice,progreso:progreso});

                
              
       }else{
        console.log('Done!');
        this.props.recalcular_estado(false);
        this.props.termino();
       }
   }
 


}

    render(){
      let {recalcular,indice,progreso} = this.props.cliente;

      let data= this.props.lista;
      let min = parseFloat(((data.length-indice)*0.8)/60).toFixed(2) ;


      return(
       
                
                  <div className="row">
                    <div className="col-12"> 
                       <div className="text-center">{progreso}%  Clientes {indice} de {data.length}</div>
                       <div className="text-center">Tiempo Estimado {min} Min.</div>
                       <Progress animated  value={progreso} />
                       <Progress animated value={progreso} />
                    </div>
                  </div>
               
      );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        cliente : state.cliente,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(KardexProveedor)


// WEBPACK FOOTER //
// ./src/views/clientes/BarraProgreso.js